import { useLanguage } from "@/contexts/LanguageContext";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { HeaderBrand } from "@/components/HeaderBrand";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { NAV_ITEMS, trackEvent } from "@/lib/site";
import { Menu } from "lucide-react";
import { useState } from "react";
import { Link, useLocation } from "wouter";
export function PublicHeader() {
  const {
    tx,
    tf,
    href: localeHref,
    dateLocale
  } = useLanguage();
  const [location] = useLocation();
  const [open, setOpen] = useState(false);
  return <header className="sticky top-0 z-50 border-b border-black/8 bg-[#F7F3EB]/94 backdrop-blur-xl">
      <div className="container flex h-[92px] items-center gap-5 lg:h-[110px]">
        <HeaderBrand label={tx("CYPRUS PRIVÉ Startseite")} />
        <nav className="hidden min-w-0 flex-1 items-center justify-center gap-3 min-[1400px]:flex" aria-label={tx("Hauptnavigation")}>
          {tx(NAV_ITEMS.map(item => <Link key={item.href} href={item.href} className={`whitespace-nowrap text-[10px] font-bold uppercase tracking-[.08em] ${location === item.href ? "text-[#76582E]" : "text-[#3E3A34] hover:text-black"}`}>
              {tx(item.label)}
              {tx(item.href === "/private-investments" && <span className="mt-1 block text-center text-[8px] tracking-wider text-[#76582E]">{tx("AUF ANFRAGE")}</span>)}
            </Link>))}
        </nav>
        <div className="ml-auto hidden shrink-0 items-center gap-2 min-[1400px]:flex">
          <LanguageSwitcher />
          <Button asChild className="rounded-none bg-[#A98950] px-5 text-[11px] font-bold tracking-[.14em] text-[#101010] hover:bg-[#C4A46B]">
            <Link href="/setup-check" onClick={() => trackEvent("setup_check_started", {
            placement: "header"
          })}>{tx("SETUP-CHECK")}</Link>
          </Button>
        </div>
        <div className="ml-auto flex items-center gap-2 min-[1400px]:hidden">
          <LanguageSwitcher />
          <Button asChild size="sm" className="hidden rounded-none bg-[#A98950] text-[10px] font-bold tracking-[.08em] text-[#101010] hover:bg-[#C4A46B] sm:inline-flex">
            <Link href="/setup-check">{tx("SETUP-CHECK")}</Link>
          </Button>
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild><Button variant="outline" size="icon" className="rounded-none border-black/15 bg-transparent" aria-label={tx("Menü öffnen")}><Menu className="h-5 w-5" /></Button></SheetTrigger>
            <SheetContent side="right" className="w-[88vw] max-w-sm overflow-y-auto border-l-[#3a352e] bg-[#101010] p-0 text-[#F7F3EB]">
              <SheetHeader className="border-b border-white/10 p-6 text-left">
                <SheetTitle className="font-display text-3xl font-semibold text-[#F7F3EB]">{tx("CYPRUS PRIVÉ")}</SheetTitle>
                <p className="text-[10px] font-semibold tracking-[.16em] text-[#D8BC88]">{tx("IHR SERVICE RUND UM NORDZYPERN")}</p>
              </SheetHeader>
              <nav className="flex flex-col px-6 py-5" aria-label={tx("Mobile Navigation")}>
                {tx(NAV_ITEMS.map((item, index) => <Link key={item.href} href={item.href} onClick={() => setOpen(false)} className="flex items-center justify-between border-b border-white/10 py-3.5 text-sm font-semibold tracking-wide text-white/85 hover:text-[#C4A46B]">
                    <span>{tx(item.label)}{tx(item.href === "/private-investments" && <span className="mt-1 block text-[10px] font-normal text-[#D8BC88]">{tx("Auf Anfrage · individuelle Konditionen")}</span>)}</span><span className="font-display text-lg text-[#C4A46B]">{tx(String(index + 1).padStart(2, "0"))}</span>
                  </Link>))}
              </nav>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>;
}
